import { FC, useMemo } from 'react';
import { FormatLinkedText } from 'brg-longread';
import { API, Endpoints, Project } from '@brg/api';
import {
  LongreadBlockWrapper,
  ProjectsPrintWrap,
  ProjectList,
  ProjectItemWrapper,
  CaptionBlockWrapper,
} from '../../styles/LongreadBlockRenderer.styles';
import { useGetProjectListByIds } from '../../hooks';
import { getProjectImage } from '../../utils/projectUtils';
import { getProjectHrefPrefix } from '../../../../pages/projectEdit/support/getProjectHrefPrefix';
import { MAX_PROJECTS_IN_BLOCK } from '../../constants';
import { invertColor } from '../../utils/colorUtils';
import { useTranslation } from 'react-i18next';

interface ProjectsBlockProps {
  block: any;
  backgroundColor?: string;
}

export const ProjectsBlock: FC<ProjectsBlockProps> = ({ block, backgroundColor }) => {
  const { t, i18n: { language } } = useTranslation();
  const projectIds = useMemo(() => block.projectIds || [], [block.projectIds]);
  const { projects, loading } = useGetProjectListByIds(projectIds);
  const isLoading = block.postId === 'loading' || block.postId === 'updating';

  const fullProjectsList = useMemo(() =>
    projectIds.map((id: string) => projects?.find((project: any) => project.projectId === id) || null),
    [projectIds, projects]
  );

  const isPresentation = useMemo(
    () =>
      projects?.some((project: any) => {
        const viewType = project?.longread?.viewType || project?.projectType;
        return ['fixed-ratio-small', 'fixed-ratio-large', 't-shape'].includes(viewType);
      }),
    [projects]
  );

  // @ts-ignore
  const presentationItem = useMemo(() => projects?.length > 0 ? projects[0] : undefined, [projects]);

  const defaultTextColor = useMemo(() => {
    if (!backgroundColor) return '#151514';
    return invertColor(backgroundColor, '#FEFEFE', '#151514');
  }, [backgroundColor]);


  if (isLoading || loading) {
    return (
      <LongreadBlockWrapper>
        <ProjectsPrintWrap style={{ backgroundColor: backgroundColor }}>
          <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', width: '100%', height: '100%' }}>
            Загрузка...
          </div>
        </ProjectsPrintWrap>
      </LongreadBlockWrapper>
    );
  }

  if (isPresentation && presentationItem) {
    const hrefPrefix = getProjectHrefPrefix(presentationItem);
    const projectImage = getProjectImage(presentationItem);
    
    return (
      <LongreadBlockWrapper>
        <ProjectsPrintWrap style={{ backgroundColor: backgroundColor }}>
          <ProjectItemWrapper 
            href={`${hrefPrefix}/project/${presentationItem.projectId}`}
            target="_blank"
            rel="noopener noreferrer"
            style={{ width: '100%', height: '100%' }}
            onClick={(e) => e.stopPropagation()}
          >
            {projectImage && (
              <img 
                src={`${Endpoints.files}/${projectImage.url}`}
                alt='project'
                style={{ width: '100%', height: '100%', objectFit: 'cover' }}
              />
            )}
          </ProjectItemWrapper>
        </ProjectsPrintWrap>
      </LongreadBlockWrapper>
    );
  }

  return (
    <LongreadBlockWrapper>
      <ProjectsPrintWrap style={{ backgroundColor: backgroundColor }}>
        <ProjectList>
          {fullProjectsList.slice(0, MAX_PROJECTS_IN_BLOCK).map((project: any, index: number) => {
            if(!project) return null;
            const projectImage = getProjectImage(project);
            const hrefPrefix = getProjectHrefPrefix(project);
            return (
              <ProjectItemWrapper 
                key={project.projectId || index}
                href={`${hrefPrefix}/project/${project.projectId}`}
                target="_blank"
                rel="noopener noreferrer"
                onClick={(e) => e.stopPropagation()}
              >
                {projectImage ? (
                  <img 
                    src={`${Endpoints.files}/${projectImage.url}`}
                    alt={project.title}
                  />
                ) : (
                  <div style={{ width: '100%', height: '100%', background: '#f0f0f0', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                    {API.lang(project.title, language)}
                  </div>
                )}
              </ProjectItemWrapper>
            );
          })}
        </ProjectList>
        {!block.text && block.caption && (
          <CaptionBlockWrapper textColor={defaultTextColor}>
            <FormatLinkedText text={block.caption} />
          </CaptionBlockWrapper>
        )}
      </ProjectsPrintWrap>
    </LongreadBlockWrapper>
  );
};
import { FC, useMemo } from 'react';
import { FormatLinkedText } from 'brg-longread';
import { API, Endpoints, Project } from '@brg/api';
import {
  LongreadBlockWrapper,
  ProjectsPrintWrap,
  ProjectList,
  ProjectItemWrapper,
  CaptionBlockWrapper,
} from '../../styles/LongreadBlockRenderer.styles';
import { useGetProjectListByIds } from '../../hooks';
import { getProjectImage } from '../../utils/projectUtils';
import { getProjectHrefPrefix } from '../../../../pages/projectEdit/support/getProjectHrefPrefix';
import { MAX_PROJECTS_IN_BLOCK } from '../../constants';
import { invertColor } from '../../utils/colorUtils';
import { useTranslation } from 'react-i18next';

interface ProjectsBlockProps {
  block: any;
  backgroundColor?: string;
}

export const ProjectsBlock: FC<ProjectsBlockProps> = ({ block, backgroundColor }) => {
  const { t, i18n: { language } } = useTranslation();
  const projectIds = useMemo(() => block.projectIds || [], [block.projectIds]);
  const { projects, loading } = useGetProjectListByIds(projectIds);
  const isLoading = block.postId === 'loading' || block.postId === 'updating';

  const fullProjectsList = useMemo(() =>
    projectIds.map((id: string) => projects?.find((project: any) => project.projectId === id) || null),
    [projectIds, projects]
  );

  const isPresentation = useMemo(
    () =>
      projects?.some((project: any) => {
        const viewType = project?.longread?.viewType || project?.projectType;
        return ['fixed-ratio-small', 'fixed-ratio-large', 't-shape'].includes(viewType);
      }),
    [projects]
  );

  // @ts-ignore
  const presentationItem = useMemo(() => projects?.length > 0 ? projects[0] : undefined, [projects]);

  const defaultTextColor = useMemo(() => {
    if (!backgroundColor) return '#151514';
    return invertColor(backgroundColor, '#FEFEFE', '#151514');
  }, [backgroundColor]);


  if (isLoading || loading) {
    return (
      <LongreadBlockWrapper>
        <ProjectsPrintWrap style={{ backgroundColor: backgroundColor }}>
          <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', width: '100%', height: '100%' }}>
            Загрузка...
          </div>
        </ProjectsPrintWrap>
      </LongreadBlockWrapper>
    );
  }

  if (isPresentation && presentationItem) {
    const hrefPrefix = getProjectHrefPrefix(presentationItem);
    const projectImage = getProjectImage(presentationItem);
    
    return (
      <LongreadBlockWrapper>
        <ProjectsPrintWrap style={{ backgroundColor: backgroundColor }}>
          <ProjectItemWrapper 
            href={`${hrefPrefix}/project/${presentationItem.projectId}`}
            target="_blank"
            rel="noopener noreferrer"
            style={{ width: '100%', height: '100%' }}
            onClick={(e) => e.stopPropagation()}
          >
            {projectImage && (
              <img 
                src={`${Endpoints.files}/${projectImage.url}`}
                alt='project'
                style={{ width: '100%', height: '100%', objectFit: 'cover' }}
              />
            )}
          </ProjectItemWrapper>
        </ProjectsPrintWrap>
      </LongreadBlockWrapper>
    );
  }

  return (
    <LongreadBlockWrapper>
      <ProjectsPrintWrap style={{ backgroundColor: backgroundColor }}>
        <ProjectList>
          {fullProjectsList.slice(0, MAX_PROJECTS_IN_BLOCK).map((project: any, index: number) => {
            if(!project) return null;
            const projectImage = getProjectImage(project);
            const hrefPrefix = getProjectHrefPrefix(project);
            return (
              <ProjectItemWrapper 
                key={project.projectId || index}
                href={`${hrefPrefix}/project/${project.projectId}`}
                target="_blank"
                rel="noopener noreferrer"
                onClick={(e) => e.stopPropagation()}
              >
                {projectImage ? (
                  <img 
                    src={`${Endpoints.files}/${projectImage.url}`}
                    alt={project.title}
                  />
                ) : (
                  <div style={{ width: '100%', height: '100%', background: '#f0f0f0', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                    {API.lang(project.title, language)}
                  </div>
                )}
              </ProjectItemWrapper>
            );
          })}
        </ProjectList>
        {!block.text && block.caption && (
          <CaptionBlockWrapper textColor={defaultTextColor}>
            <FormatLinkedText text={block.caption} />
          </CaptionBlockWrapper>
        )}
      </ProjectsPrintWrap>
    </LongreadBlockWrapper>
  );
};
